import { Alert, Box, Button, Typography } from '@mui/material';

export function ProviderIntakeSetupNotice({
  canJoin,
  joining,
  onJoin,
  onBack,
}: {
  canJoin: boolean;
  joining: boolean;
  onJoin: () => void;
  onBack: () => void;
}) {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Set up your provider intake
      </Typography>
      <Alert severity="info">
        Your practice is set up, but you are not on its intake provider roster yet.
        {canJoin
          ? ' Add yourself if you also need credentialing or billing services as a provider.'
          : ' Ask your practice administrator to add you to the provider roster.'}
      </Alert>
      <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
        {canJoin && (
          <Button variant="contained" disabled={joining} onClick={onJoin}>
            {joining ? 'Adding you…' : 'Add myself to the provider roster'}
          </Button>
        )}
        <Button onClick={onBack}>Back to key questions</Button>
      </Box>
    </Box>
  );
}
